module.exports = __WEBPACK_EXTERNAL_MODULE_dijits_auth_loginContainer__;


//////////////////
// WEBPACK FOOTER
// external "dijits/auth/loginContainer"
// module id = dijits/auth/loginContainer
// module chunks = 1